import React from "react";

export default ({className}) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="editor_bold-a"
            d="M8.19265419,13 L4,13 L4,3 L8.15107415,3 C9.96673597,3 11.1379071,3.97713098 11.1379071,5.49480249 C11.1379071,6.56895357 10.3409563,7.5045045 9.31531532,7.67082467 L9.31531532,7.72626473 C10.6735967,7.85793486 11.6230076,8.83506584 11.6230076,10.1586972 C11.6230076,11.9189189 10.3270963,13 8.19265419,13 Z M5.78794179,4.39293139 L5.78794179,7.21344421 L7.42342342,7.21344421 C8.67082467,7.21344421 9.37075537,6.68676369 9.37075537,5.75814276 C9.37075537,4.88496188 8.76784477,4.39293139 7.7006237,4.39293139 L5.78794179,4.39293139 Z M5.78794179,11.6070686 L7.78378378,11.6070686 C9.1004851,11.6070686 9.8004158,11.0595981 9.8004158,10.033957 C9.8004158,9.01524602 9.07969508,8.48163548 7.70755371,8.48163548 L5.78794179,8.48163548 L5.78794179,11.6070686 Z"/>
    </defs>
    <g>
      <use xlinkHref="#editor_bold-a"/>
    </g>
  </svg>
);
